var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2666 12.0582V15.7552H13.1236V12.3052C13.1236 11.4392 12.8136 10.8482 12.0376 10.8482C11.4456 10.8482 11.0926 11.2462 10.9376 11.6322C10.8816 11.7702 10.8666 11.9622 10.8666 12.1542V15.7552H8.7226C8.7226 15.7552 8.7516 9.91322 8.7226 9.30822H10.8666V10.2212L10.8526 10.2422H10.8666V10.2212C11.1516 9.78122 11.6596 9.15622 12.7986 9.15622C14.2086 9.15622 15.2666 10.0782 15.2666 12.0582ZM6.4796 6.19922C5.7466 6.19922 5.2666 6.68122 5.2666 7.31322C5.2666 7.93322 5.7326 8.42822 6.4516 8.42822H6.4656C7.2136 8.42822 7.6786 7.93222 7.6786 7.31322C7.6646 6.68122 7.2136 6.19922 6.4796 6.19922ZM5.3936 15.7552H7.5376V9.30822H5.3936V15.7552Z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2666 18.9282C12.3883 18.9282 14.4232 18.0854 15.9235 16.5851C17.4237 15.0848 18.2666 13.05 18.2666 10.9282C18.2666 8.80649 17.4237 6.77166 15.9235 5.27137C14.4232 3.77108 12.3883 2.92822 10.2666 2.92822C8.14487 2.92822 6.11004 3.77108 4.60975 5.27137C3.10946 6.77166 2.2666 8.80649 2.2666 10.9282C2.2666 13.05 3.10946 15.0848 4.60975 16.5851C6.11004 18.0854 8.14487 18.9282 10.2666 18.9282ZM10.2666 20.9282C4.7436 20.9282 0.266602 16.4512 0.266602 10.9282C0.266602 5.40522 4.7436 0.928223 10.2666 0.928223C15.7896 0.928223 20.2666 5.40522 20.2666 10.9282C20.2666 16.4512 15.7896 20.9282 10.2666 20.9282Z",
    fill: "#F7F8FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7a3620010fa5a651ebedb358f9f3b67f.svg";
export { ForwardRef as ReactComponent };